<template>
  <div class="date-range">
    <b-row>
      <b-col lg="6">
        <div class="calendar-header">
          <label class="calendar-header-label">From:</label>
          <b-input
            v-model="startDateModel"
            size="sm"
            class="calendar-header-input"
            v-facade="'##/##/####'"
            placeholder="MM/DD/YYYY"
          />
        </div>
        <calendar
          v-model="startDateCalendar"
          :max="endDate"
          :date-info-fn="dateClasses"
        />
      </b-col>
      <div class="vertical-divider"></div>
      <b-col lg="6">
        <div class="calendar-header">
          <label class="calendar-header-label mb-0 mr-3 text-dark-gray"
            >To:</label
          >
          <b-input
            v-model="endDateModel"
            size="sm"
            class="calendar-header-input"
            v-facade="'##/##/####'"
            placeholder="MM/DD/YYYY"
          />
        </div>
        <calendar
          v-model="endDateCalendar"
          :min="startDate"
          :date-info-fn="dateClasses"
        />
      </b-col>
    </b-row>
    <div class="d-flex justify-content-end text-buttons">
      <div class="mr-2" @click="clearSelection">Cancel</div>
      <div class="mr-2" @click="submitSelection">Ok</div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { defineComponent } from "vue";
import { formatDateOnly, formatDateOnlyMysql } from "../../helpers/date";
import Calendar from "./Calendar.vue";

export default defineComponent({
  name: "DateRange",
  components: { Calendar },
  props: {
    startDate: { type: [String, Date], default: null },
    endDate: { type: [String, Date], default: null }
  },
  computed: {
    startDateModel: {
      get() {
        if (moment(this.startDate, "YYYY-MM-DD", true).isValid()) {
          return formatDateOnly(this.startDate);
        }
        return this.startDate;
      },
      set(value) {
        if (moment(value, "MM/DD/YYYY", true).isValid()) {
          const date = formatDateOnlyMysql(value, "MM/DD/YYYY");
          this.$emit("update:startDate", date);
        }
      }
    },
    startDateCalendar: {
      get() {
        return this.startDate;
      },
      set(value) {
        const date = formatDateOnlyMysql(value);
        this.$emit("update:startDate", date);
      }
    },
    endDateModel: {
      get() {
        if (moment(this.endDate, "YYYY-MM-DD", true).isValid()) {
          return formatDateOnly(this.endDate);
        }
        return this.endDate;
      },
      set(value) {
        if (moment(value, "MM/DD/YYYY", true).isValid()) {
          const date = formatDateOnlyMysql(value, "MM/DD/YYYY");
          this.$emit("update:endDate", date);
        }
      }
    },
    endDateCalendar: {
      get() {
        return this.endDate;
      },
      set(value) {
        const date = formatDateOnlyMysql(value);
        this.$emit("update:endDate", date);
      }
    }
  },
  methods: {
    formattedDate(date) {
      return date ? this.formatDateOnly(date) : "";
    },
    dateClasses(ymd, date) {
      if (
        (!this.endDate && this.startDate && date >= this.startDate) ||
        (!this.startDate && this.endDate && date <= this.endDate) ||
        (this.startDate &&
          date >= this.startDate &&
          this.endDate &&
          date <= this.endDate)
      )
        return "selected-date-range";
      return "";
    },
    clearSelection() {
      this.$emit("update:startDate", null);
      this.$emit("update:endDate", null);
      this.$emit("cancelFilter");
    },
    submitSelection() {
      this.$emit("applyFilter");
    }
  }
});
</script>

<style scoped lang="scss">
.date-range {
  background-color: white;
  padding: 15px;
  border-radius: 7px;
  width: 530px;

  .calendar-header {
    display: flex;
    padding: 0 10px;
    align-items: center;
    justify-content: center;

    &-label {
      margin-bottom: 0 !important;
      margin-right: 7px;
      color: #707070;
    }

    &-input {
      background-color: white;
      box-shadow: 0px 0px 2px 0px #00000040 inset;
      font-size: 16px !important;
      text-align: center;
      color: #707070;
      width: 140px;
    }
  }

  :deep(.selected-date-range) {
    span.btn {
      background-color: #6f8ae3 !important;
    }
  }

  .vertical-divider {
    height: 220px;
    border-right: 1px solid rgba(black, 0.15);
    margin-right: -2px;
    margin-left: -2px;
    align-self: center;
  }
}

.text-buttons {
  color: #363abb;
  font-family: Bahnschrift;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  flex-shrink: 0;
  width: 100%;
  margin-left: auto;
  height: 23px;
}
</style>
